import { render, staticRenderFns } from "./Needs.vue?vue&type=template&id=e7d0c128&scoped=true&"
import script from "./Needs.vue?vue&type=script&lang=js&"
export * from "./Needs.vue?vue&type=script&lang=js&"
import style0 from "./Needs.vue?vue&type=style&index=0&id=e7d0c128&lang=less&scoped=true&"
import style1 from "./Needs.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7d0c128",
  null
  
)

export default component.exports